import React, { memo } from 'react';

import size from '@/assets/theme/size';
import MenuContainer from '@/components/atomic/atoms/navigation/menu/container';
import MenuItem from '@/components/atomic/atoms/navigation/menu/item';
import Hamburger from '@/components/atomic/molecules/navigation/hamburger';
import type { HamburgerMenuListProps } from '@/components/atomic/molecules/navigation/hamburger-menu-list/typings';
import withExposer from '@/hocs/with-exposer';
import { BasicComponentProps } from '@/typings/generic';

const { desktopSm } = size;

const HamburgerMenuListComponent: React.FC<
	HamburgerMenuListProps & BasicComponentProps
> = ({ mobileBurgerAriaLabel, mobileBurgerMenuLabel, $exposerSuffix }) => {
	return (
		<MenuContainer $exposerSuffix={$exposerSuffix}>
			<MenuItem
				$exposerSuffix={$exposerSuffix}
				$LinkProps={{ $paddingLeft: 16, $paddingRight: 16, $gap: 10 }}
				$breakpoints={{
					[desktopSm]: {
						$LinkProps: { $paddingLeft: 26, $paddingRight: 26 },
					},
				}}
			>
				<Hamburger
					mobileBurgerAriaLabel={mobileBurgerAriaLabel}
					mobileBurgerMenuLabel={mobileBurgerMenuLabel}
					$exposerSuffix={$exposerSuffix}
				/>
			</MenuItem>
		</MenuContainer>
	);
};

const HamburgerMenuList = memo(
	withExposer(HamburgerMenuListComponent, 'hamburgerMenuList'),
);

export default HamburgerMenuList;
